import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { BaseService } from '../base/base.service';
import { WalletDesign, WalletDesignAnalysis, WalletDesignCardOrder, WalletDesignList } from './wallet-design';
import { WalletDesignSerializer } from './wallet-design.serializer';

@Injectable({
  providedIn: 'root'
})
export class WalletDesignService extends BaseService<WalletDesign, WalletDesignList> {

  constructor(http: HttpClient) {
    super(http);
    this.endpoint = 'wallet_designs';
    this.serializer = new WalletDesignSerializer();
  }

  analyze(personalizedCardOrderId: number): Observable<WalletDesignAnalysis> {
    const formData = new FormData();
    formData.append('personalized_card_order_id', String(personalizedCardOrderId));
    return this.http.post<WalletDesignAnalysis>(`${environment.base_url}wallet_designs/analyze`, formData);
  }

  cardOrders(clientId: number): Observable<WalletDesignCardOrder[]> {
    const params = new HttpParams().set('client_id', String(clientId));
    return this.http.get<WalletDesignCardOrder[]>(`${environment.base_url}wallet_designs/card_orders`, { params });
  }
}
